import { FC, ReactNode } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./styles.module.scss";

/** The `SidebarNavSection` component properties. */
export interface SidebarNavSectionProps {

  /**
   * The navigation section ID.
   * @deprecated ID is no longer used in sidebar nav sections.
   */
  readonly id?: string;

  /** The section title. */
  readonly title?: string;

  /** The section test ID. */
  readonly testId?: string;

  /**
   * Indicates whether the section has a divider.
   * @deprecated Sidebar now automatically assigns dividers between elements.
   */
  readonly sectionDivider?: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The in-context sidebar navigation component. */
export const SidebarNavSection: FC<SidebarNavSectionProps> = (props) => {
  const { testId, title, children } = props;

  return (
    <Stack className={styles.SidebarNavSection} spacing="small" testId={testId}>
      {title && <div className="title">{title}</div>}
      {children}
    </Stack>
  );
};
